// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hunters-container[data-v-287ed56a]{background:#000}.hunters-menu[data-v-287ed56a]{max-width:500px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
